import Vue from 'vue';
// eslint-disable-next-line
export const doorlockMobileKeyEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/doorlocks/doorlockMobileKeyEventBus.js